import SchoolReport from './template';
export default SchoolReport;
